import axiosInstance from "./axiosInstance";

const UserService = {

    getUserInfo: async() => {
            const response = await axiosInstance.get("/api/users/getByUsername");
            return response.data; // Returns the created customer data
    },
    getCompanyBankInfo: async() => {
            const response = await axiosInstance.get("/api/clientBanks");
            return response.data; // Returns the created customer data
    },

    getCompanyInfo: async() => {
            const response = await axiosInstance.get("/api/clients/getByClient");
            return response.data; // Returns the created customer data
    },

    updateCompanyInfo: async(companyInfo) => {
            const response = await axiosInstance.put("/api/clients", companyInfo);
            return response.data; // Returns the created customer data
    },

    createOrUpdateBankingInfo: async(editBankingData) => {
            if(editBankingData.id !== undefined) {
                const response = await axiosInstance.put("/api/clientBanks/" + editBankingData.id, editBankingData);
                return response.data; // Returns the created customer data
            }
            else {
                const response = await axiosInstance.post("/api/clientBanks", editBankingData);
                return response.data; // Returns the created customer data
            }
    },

    changePassword: async(changePasswordData) => {
            const response = await axiosInstance.put("/api/users/change-password", changePasswordData);
            return response.data; // Returns the created customer data
    },

    savePersonalInformation: async(editPersonalInformation) => {
            const response = await axiosInstance.put("/api/users", editPersonalInformation);
            return response.data; // Returns the created customer data

    },

    changeLanguage: async (language)  => {
        const response = await axiosInstance.put("/api/users/change-language", language);
        return response.data;
    },

    getAllUsers: async () => {
        const response = await axiosInstance.get('/api/users?page=0&size=200');
        return response.data?.content || response.data || [];
    },
}

export default UserService